var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_249_1563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4422 3.62012H14.1748V11.6102H37.5572V7.73354C37.5572 5.46518 35.7112 3.62012 33.4422 3.62012Z",
    fill: "#CED9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5352 12.8398H0V5.42587C0 2.70923 2.21068 0.499512 4.92828 0.499512H12.1336C12.8497 0.499512 13.5396 0.650436 14.1664 0.934021C15.0418 1.32848 15.7939 1.97864 16.3213 2.82811L22.5352 12.8398Z",
    fill: "#1640C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 14.4994V38.3807C42 40.652 40.1511 42.4993 37.8789 42.4993H4.12111C1.84891 42.4993 0 40.652 0 38.3807V10.3799H37.8789C40.1511 10.3799 42 12.2278 42 14.4994Z",
    fill: "#2354E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 14.4994V38.3807C42 40.652 40.1511 42.4993 37.8789 42.4993H21V10.3799H37.8789C40.1511 10.3799 42 12.2278 42 14.4994Z",
    fill: "#1849D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.048 26.4395C32.048 32.532 27.0919 37.4884 21.0001 37.4884C14.9083 37.4884 9.95215 32.532 9.95215 26.4395C9.95215 20.3481 14.9083 15.3916 21.0001 15.3916C27.0919 15.3916 32.048 20.3481 32.048 26.4395Z",
    fill: "#E7ECFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0479 26.4395C32.0479 32.532 27.0918 37.4884 21 37.4884V15.3916C27.0918 15.3916 32.0479 20.3481 32.0479 26.4395Z",
    fill: "#CED9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5612 26.5748C24.3308 26.77 24.0485 26.8651 23.7688 26.8651C23.4185 26.8651 23.0705 26.7168 22.827 26.4277L22.2307 25.7209V30.3489C22.2307 31.0282 21.6795 31.5794 21.0002 31.5794C20.3209 31.5794 19.7698 31.0282 19.7698 30.3489V25.7209L19.1734 26.4277C18.7344 26.9472 17.9587 27.0135 17.4392 26.5748C16.9201 26.1368 16.8535 25.3607 17.2915 24.8413L19.7271 21.9538C20.0447 21.5783 20.508 21.3623 21.0002 21.3623C21.4924 21.3623 21.9558 21.5783 22.2733 21.9538L24.7089 24.8413C25.147 25.3607 25.0803 26.1368 24.5612 26.5748Z",
    fill: "#6C8DEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.561 26.5748C24.3306 26.77 24.0483 26.8651 23.7686 26.8651C23.4183 26.8651 23.0703 26.7168 22.8268 26.4277L22.2305 25.7209V30.3489C22.2305 31.0282 21.6793 31.5794 21 31.5794V21.3623C21.4922 21.3623 21.9555 21.5783 22.2731 21.9538L24.7087 24.8413C25.1467 25.3607 25.0801 26.1368 24.561 26.5748Z",
    fill: "#3B67E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_249_1563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0 0.499512)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.69b0687d20f65fad6b031d0060f13901.svg";
export { ForwardRef as ReactComponent };